import React, { useState, useEffect, useRef } from 'react';

const TestimonialReviews = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isPlaying, setIsPlaying] = useState({});
  const [isAutoPlaying, setIsAutoPlaying] = useState(true);
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });
  const [showVideoModal, setShowVideoModal] = useState(false);
  const [currentVideo, setCurrentVideo] = useState(null);
  const containerRef = useRef(null);


  const testimonials = [
    {
      id: 1,
      name: "Kishan Kumar",
      company: "HONEYWELL",
      role: "Senior Data Scientist",
      image: "assets/images/reviews/kishanReview1.jpg",
      quote: "One of best course I find to improve my ML and AI Skills. It helps in changing my domain to Data Science field.",
      fullReview: "Choosing Logicmojo was my best decision ever. The instructors were encouraging and glad to answer questions.",
      rating: 5,
      placement: "Got 40% hike",
      salary: "₹12 LPA → ₹18 LPA",
      duration: "6 months",
      skills: ["Python", "Machine Learning", "Deep Learning", "SQL"],
      videoThumbnail: "assets/images/reviews/KishanReview.jpg",
      videoUrl: "https://www.youtube.com/embed/f2dPrBYnlTo",
      fullStoryUrl: "https://logicmojo.com/kishan-review-success-story", // Add your link here
      bgGradient: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)"
    },
  
    {
      id: 2,
      name: "Ujwal Singh",
      company: "Uber",
      role: "Senior Data Scientist",
      image: "assets/images/reviews/ujwal.jpg",
      quote: "One of the best courses I found to improve my Data Science skills. It gave me the confidence to move into the Data Scientist role.",
    fullReview: "Enrolling in the Logicmojo Data Science Course was the best career decision I made. The instructors are supportive, patient and always ready to clarify doubts, which made learning smooth and engaging.",
      rating: 5,
      placement: "Got 40% hike",
      salary: "₹22 LPA → ₹48 LPA",
      duration: "6 months",
      skills: ["Python", "Machine Learning", "Deep Learning", "GenAI"],
      videoThumbnail: "assets/images/reviews/ujwalreview.jpg",
      videoUrl: "https://www.youtube.com/embed/WneODI6nTWI?si=tAEg5wliPaEq0pbt",
      fullStoryUrl: "https://logicmojo.com/ujjwal-data-science-journey/", // Add your link here
      bgGradient: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)"
    },
    {
      id: 3,
      name: "Sony Amancha",
      company: "Google Operations Center",
      role: "Quality Assurance Specialist",
      image: "assets/images/reviews/sony.jpg",
      quote: "The best decision I made to level up my Data Science skills. It gave me the confidence to shift my career direction.",
      fullReview: "Joining the Logicmojo Data Science Course completely changed my approach to learning. The instructors explained concepts with patience and real-world clarity, especially in Python and Machine Learning. This helped me transition confidently into advanced QA and analytics work.",
      rating: 5,
      placement: "Career shift into advanced analytics",
      salary: "₹15 LPA → ₹38 LPA",
      duration: "7 months",
      skills: ["Python", "Data Science", "Machine Learning", "Deep Learning"],
      videoThumbnail: "assets/images/reviews/sonyreview.jpg",
      videoUrl: "https://www.youtube.com/embed/pPuK7fN8238?si=-_g8lDZtYiINIX8s",
      fullStoryUrl: "https://logicmojo.com/sony-data-science-journey/",
      bgGradient: "linear-gradient(135deg, #ff9966 0%, #ff5e62 100%)"
    },
    {
      id: 4,
      name: "Manikandan Baskaran",
      company: "Bank of America",
      role: "Software Engineer",
      image: "assets/images/reviews/mani.jpg",
      quote: "Best course for mastering Maths and Data Science fundamentals. It gave me the clarity I needed in ML algorithms.",
      fullReview: "Coming from an ETL and Informatica background, I always felt I lacked the core Data Science and ML foundation. Logicmojo’s course filled that gap. The way the instructors covered statistics, ML algorithms, and real-world projects made me confident to apply Data Science skills at work and aim for bigger roles.",
      rating: 5,
      placement: "Upskilled for advanced roles",
      salary: "Boosted career trajectory",
      duration: "7 months",
      skills: ["Python", "SQL", "Machine Learning", "Deep Learning", "ETL"],
      videoThumbnail: "assets/images/reviews/manireview.jpg",
      videoUrl: "https://www.youtube.com/embed/R3Ijsn462SM?si=n-UJl3a2FnymTORL",
      fullStoryUrl: "https://logicmojo.com/manikandan-baskaran-data-science-journey/",
      bgGradient: "linear-gradient(135deg, #36d1dc 0%, #5b86e5 100%)"
    },
    {
      id: 5,
      name: "Sampada",
      company: "HCL",
      role: "Data Analyst",
      image: "assets/images/reviews/SampadaReview1.jpg",
      quote: "Project based learning is best part of the course. Almost every topic has multiple set of projects to build portfolio.",
      fullReview: "Transitioning from a non-tech role, Logicmojo's data science certification equipped me with the skills needed.",
      rating: 5,
      placement: "Career Switch Success",
      salary: "₹8 LPA → ₹15 LPA",
      duration: "5 months",
      skills: ["Data Analysis", "Tableau", "Power BI", "Statistics"],
      videoThumbnail: "assets/images/reviews/SampadaReview.jpg",
      videoUrl: "https://www.youtube.com/embed/yC9naVtGCTM",
      fullStoryUrl: "https://logicmojo.com/sampada-review-success-story", // Add your link here
      bgGradient: "linear-gradient(135deg, #f093fb 0%, #f5576c 100%)"
    },
    
    {
      id: 6,
      name: "Jayanth Reddy",
      company: "VIRTUSA",
      role: "ML Engineer",
      image: "assets/images/reviews/Jayanthreview.jpg",
      quote: "Thanks Logicmojo for data science classes. Trainer teaches all concepts very concise and clear.",
      fullReview: "I had a great learning experience at Logicmojo. The faculties here are top notch throughout the journey.",
      rating: 5,
      placement: "Promoted to ML Engineer",
      salary: "₹10 LPA → ₹16 LPA",
      duration: "4 months",
      skills: ["TensorFlow", "PyTorch", "AWS", "Docker"],
      videoThumbnail: "assets/images/reviews/JayanthReddy.jpg",
      videoUrl: "https://www.youtube.com/embed/7QwkYLxDnOU",
      fullStoryUrl: "https://logicmojo.com/jayanth-review-success-story", // Add your link here
      bgGradient: "linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)"
    },
    {
      id: 7,
      name: "Arvind R",
      company: "VIRTUSA",
      role: "Data Engineer",
      image: "assets/images/reviews/ArvindReview.jpg",
      quote: "Classes are good and very structured way of explaining topics. I applied ML concepts in my current project.",
      fullReview: "I moved from teaching to data science with Logicmojo's help. Their course was easy to follow.",
      rating: 5,
      placement: "Successful Transition",
      salary: "₹6 LPA → ₹14 LPA",
      duration: "7 months",
      skills: ["Spark", "Hadoop", "Python", "SQL"],
      videoThumbnail: "assets/images/reviews/ArvindReview2.jpg",
      videoUrl: "https://www.youtube.com/embed/6ff40cDPUKY",
      fullStoryUrl: "https://logicmojo.com/arvind-review-success-story", // Add your link here
      bgGradient: "linear-gradient(135deg, #fa709a 0%, #fee140 100%)"
    },
    {
      id: 8,
      name: "Kailash Patel",
      company: "FRACTAL ANALYTICS",
      role: "Data Scientist",
      image: "assets/images/reviews/Jayesh.jpg",
      quote: "Thanks Logicmojo for Data Science Classes and materials. It was really helpful for my career.",
      fullReview: "I moved from teaching to data science role with the help of Logicmojo data science course.",
      rating: 5,
      placement: "Dream Job Achieved",
      salary: "₹9 LPA → ₹20 LPA",
      duration: "6 months",
      skills: ["Python", "R", "Machine Learning", "Statistics"],
      videoThumbnail: "assets/images/reviews/KaushalReview.jpg",
      videoUrl: "https://www.youtube.com/embed/oApVRB2MAcg",
      fullStoryUrl: "https://logicmojo.com/kailash-review-success-story", // Add your link here
      bgGradient: "linear-gradient(135deg, #a8edea 0%, #fed6e3 100%)"
    },
    {
      id: 9,
      name: "Velu Rathnasabapathy",
      company: "SAP",
      role: "Vice President",
      image: "assets/images/reviews/velu.jpg",
     quote: "Clear, structured, and practical. Finally understood the ‘why’ behind ML models.",
      fullReview: "I have been a Java backend developer for years, but ML always felt fuzzy. LogicMojo’s approach—stats first, then models, then projects—clicked for me. The math was explained simply, the notebooks were clean, and the assignments forced me to think. I can now explain model choices and tradeoffs at work with confidence.",
      rating: 5,
      placement: "Upskilled for advanced roles",
      salary: "Boosted career trajectory",
      duration: "7 months",
      skills: ["Deep Learning", "SQL", "Machine Learning", "NLP", "ML"],
      videoThumbnail: "assets/images/reviews/velureview.jpg",
      videoUrl: "https://www.youtube.com/embed/heCLpcKR09Q?si=XMM3xqF3U1-8nTwD",
      fullStoryUrl: "https://logicmojo.com/manikandan-review-success-story",
      bgGradient: "linear-gradient(135deg, #36d1dc 0%, #5b86e5 100%)"
    }

  ];
  const [itemsPerPage, setItemsPerPage] = useState(window.innerWidth < 768 ? 1 : 2);

  useEffect(() => {
    const handleResize = () => setItemsPerPage(window.innerWidth < 768 ? 1 : 2);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  const totalPages = Math.ceil(testimonials.length / itemsPerPage);

  // Auto-play functionality


  // Mouse tracking for 3D effects
  useEffect(() => {
    const handleMouseMove = (e) => {
      if (containerRef.current) {
        const rect = containerRef.current.getBoundingClientRect();
        const x = (e.clientX - rect.left) / rect.width;
        const y = (e.clientY - rect.top) / rect.height;
        setMousePosition({ x, y });
      }
    };

    if (containerRef.current) {
      containerRef.current.addEventListener('mousemove', handleMouseMove);
      return () => containerRef.current?.removeEventListener('mousemove', handleMouseMove);
    }
  }, []);

  const handlePlayVideo = (testimonial) => {
    setCurrentVideo(testimonial);
    setShowVideoModal(true);
    setIsAutoPlaying(false);
  };

  const closeVideoModal = () => {
    setShowVideoModal(false);
    setCurrentVideo(null);
    setIsAutoPlaying(true);
  };

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % Math.ceil(testimonials.length / itemsPerPage));
    setIsAutoPlaying(false);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => prev === 0
  ? Math.ceil(testimonials.length / itemsPerPage) - 1
  : prev - 1
 );
    setIsAutoPlaying(false);
  };

  const goToSlide = (index) => {
    setCurrentSlide(index);
    setIsAutoPlaying(false);
  };

  const getCurrentTestimonials = () => {
    const startIndex = currentSlide * 3;
    return testimonials.slice(startIndex, startIndex + 3);
  };

  return (
    <div className="epic_testimonial_universe" ref={containerRef}>
      {/* Cinematic Background */}
      <div className="epic_testimonial_cosmic_bg">
        <div className="epic_testimonial_stars_layer"></div>
        <div className="epic_testimonial_nebula epic_testimonial_nebula_1"></div>
        <div className="epic_testimonial_nebula epic_testimonial_nebula_2"></div>
        <div className="epic_testimonial_nebula epic_testimonial_nebula_3"></div>
        <div className="epic_testimonial_aurora"></div>
      </div>

      {/* Floating Particles */}
      <div className="epic_testimonial_particles">
        {[...Array(50)].map((_, i) => (
          <div
            key={i}
            className="epic_testimonial_particle"
            style={{
              left: `${Math.random() * 100}%`,
              animationDelay: `${Math.random() * 10}s`,
              animationDuration: `${Math.random() * 5 + 10}s`
            }}
          />
        ))}
      </div>

      {/* Main Header */}
      <div className="epic_testimonial_header_galaxy">
        <div className="epic_testimonial_header_content">
          <div className="epic_testimonial_cosmic_badge">
            <div className="epic_testimonial_badge_glow"></div>
            <span className="epic_testimonial_badge_icon">⭐</span>
            <span style={{ color: 'white' }}>
  <strong>Success Universe</strong>
</span>
          </div>

          <h2 className="epic_testimonial_cosmic_title">
            <span className="epic_testimonial_title_line">Real Stories,</span>
            <span className="epic_testimonial_title_line epic_testimonial_title_highlight">Real Success</span>
          </h2>

          <p className="epic_testimonial_cosmic_subtitle">
            Witness the transformation journeys of students who conquered the Data Science galaxy
          </p>

          {/* Epic Stats Dashboard */}
          <div className="epic_testimonial_stats_constellation">
            <div className="epic_testimonial_stat_planet">
              <div className="epic_testimonial_stat_orbit"></div>
              <div className="epic_testimonial_stat_core">
                <span className="epic_testimonial_stat_number">5000+</span>
                <span className="epic_testimonial_stat_label">Success Stories</span>
              </div>
            </div>
            <div className="epic_testimonial_stat_planet epic_testimonial_stat_planet_2">
              <div className="epic_testimonial_stat_orbit"></div>
              <div className="epic_testimonial_stat_core">
                <span className="epic_testimonial_stat_number">4.9★</span>
                <span className="epic_testimonial_stat_label">Average Rating</span>
              </div>
            </div>
            <div className="epic_testimonial_stat_planet epic_testimonial_stat_planet_3">
              <div className="epic_testimonial_stat_orbit"></div>
              <div className="epic_testimonial_stat_core">
                <span className="epic_testimonial_stat_number">85%</span>
                <span className="epic_testimonial_stat_label">Career Switch</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Main Testimonials Theater */}
      <div className="epic_testimonial_theater">
        {/* Navigation Controls */}
        <button
          className="epic_testimonial_nav_portal epic_testimonial_nav_prev"
          onClick={prevSlide}
          onMouseEnter={() => setIsAutoPlaying(false)}
        >
          <div className="epic_testimonial_nav_energy"></div>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M15 18L9 12L15 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </button>

        {/* Testimonials Display */}
        
        <div className="epic_testimonial_showcase">
                  <div
            className="epic_testimonial_cards_universe"
            style={{
              display: 'flex', // Add this
              gap: '2rem',     // Add this
              transform: `translateX(-${currentSlide * 100}%)`,
            }}
          >
            
            {Array.from({ length: totalPages }).map((_, pageIndex) => (
      <div 
      key={pageIndex} 
      className="epic_testimonial_slide_dimension"
      style={{
        display: 'flex', 
        gap: '2rem' // This adds a 2rem gap between the cards
      }}
    >


               {Array.from({ length: itemsPerPage }).map((_, cardIndex) => {
          const idx =
            (pageIndex * itemsPerPage + cardIndex) % testimonials.length;
          const testimonial = testimonials[idx];
          return (
                  <div
                    key={testimonial.id}
                    className="epic_testimonial_hologram_card"
                    style={{
                      animationDelay: `${cardIndex * 0.2}s`,
                      transform: `perspective(1000px) rotateX(${(mousePosition.y - 0.5) * 5}deg) rotateY(${(mousePosition.x - 0.5) * 5}deg)`,
                      /* ← add these two: */
                      flex: `0 0 ${100 / itemsPerPage}%`,
                      maxWidth: `${100 / itemsPerPage}%`
                    }}
                    onMouseEnter={() => setIsAutoPlaying(false)}
                    onMouseLeave={() => setIsAutoPlaying(true)}
                  >
                    {/* Holographic Borders */}
                    <div className="epic_testimonial_holo_border epic_testimonial_holo_top"></div>
                    <div className="epic_testimonial_holo_border epic_testimonial_holo_right"></div>
                    <div className="epic_testimonial_holo_border epic_testimonial_holo_bottom"></div>
                    <div className="epic_testimonial_holo_border epic_testimonial_holo_left"></div>

                    {/* Video Theater */}
                    <div className="epic_testimonial_video_portal">
                      <div className="epic_testimonial_video_dimension">
                        <img
                          src={testimonial.videoThumbnail}
                          alt={testimonial.name}
                          className="epic_testimonial_video_screen"
                        />

                        {/* Holographic Overlay */}
                        <div className="epic_testimonial_holo_overlay">
                          <div className="epic_testimonial_scan_lines"></div>
                          <div className="epic_testimonial_data_stream"></div>
                        </div>

                        {/* Epic Play Button */}
                        <div
                          className="epic_testimonial_play_reactor"
                          onClick={() => handlePlayVideo(testimonial)}
                        >
                          <div className="epic_testimonial_reactor_core">
                            <div className="epic_testimonial_reactor_ring epic_testimonial_reactor_ring_1"></div>
                            <div className="epic_testimonial_reactor_ring epic_testimonial_reactor_ring_2"></div>
                            <div className="epic_testimonial_reactor_ring epic_testimonial_reactor_ring_3"></div>
                            <div className="epic_testimonial_play_icon">▶</div>
                          </div>
                          <div className="epic_testimonial_reactor_pulse"></div>
                        </div>

                        {/* Quote Hologram */}
                        <div className="epic_testimonial_quote_hologram">
                          <div className="epic_testimonial_quote_matrix">
                            <div className="epic_testimonial_quote_glyph">"</div>
                            <p className="epic_testimonial_quote_stream">
                              {testimonial.quote}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Profile Data Panel */}
                    <div className="epic_testimonial_data_panel">
                      {/* Profile Section */}
                      <div className="epic_testimonial_profile_matrix">
                        <div className="epic_testimonial_avatar_container">
                          <div className="epic_testimonial_avatar_field">
                            <img
                              src={testimonial.image}
                              alt={testimonial.name}
                              className="epic_testimonial_avatar"
                            />
                            <div className="epic_testimonial_avatar_glow"></div>
                          </div>
                          <div className="epic_testimonial_verified_seal">
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                              <path d="M9 12l2 2 4-4" stroke="currentColor" strokeWidth="2"/>
                              <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2"/>
                            </svg>
                          </div>
                        </div>

                        <div className="epic_testimonial_identity_data">
                          <h3 className="epic_testimonial_name_display">{testimonial.name}</h3>
                          <div className="epic_testimonial_company_badge">
                            <span className="epic_testimonial_company_name">{testimonial.company}</span>
                          </div>
                          <div className="epic_testimonial_role_tag">{testimonial.role}</div>
                        </div>

                        {/* Rating Constellation */}
                        <div className="epic_testimonial_rating_stars">
                          {[...Array(5)].map((_, i) => (
                            <div
                              key={i}
                              className={`epic_testimonial_star ${i < testimonial.rating ? 'epic_testimonial_star_active' : ''}`}
                            >
                              ⭐
                            </div>
                          ))}
                        </div>
                      </div>

                      {/* Success Metrics */}
                      <div className="epic_testimonial_metrics_dashboard">
                        <div className="epic_testimonial_metric_card">
                          <div className="epic_testimonial_metric_icon">💰</div>
                          <div className="epic_testimonial_metric_data">
                            <span className="epic_testimonial_metric_label">Salary Jump</span>
                            <span className="epic_testimonial_metric_value">{testimonial.salary}</span>
                          </div>
                        </div>

                        <div className="epic_testimonial_metric_card">
                          <div className="epic_testimonial_metric_icon">⚡</div>
                          <div className="epic_testimonial_metric_data">
                            <span className="epic_testimonial_metric_label">Timeline</span>
                            <span className="epic_testimonial_metric_value">{testimonial.duration}</span>
                          </div>
                        </div>
                      </div>

                      {/* Skills Matrix */}
                      <div className="epic_testimonial_skills_matrix">
                        {testimonial.skills.slice(0, 4).map((skill, index) => (
                          <div
                            key={index}
                            className="epic_testimonial_skill_node"
                            style={{ animationDelay: `${index * 0.1}s` }}
                          >
                            <div className="epic_testimonial_skill_glow"></div>
                            <span>{skill}</span>
                          </div>
                        ))}
                      </div>

                      {/* Achievement Badge */}
                      <div className="epic_testimonial_achievement_seal">
                        <div className="epic_testimonial_achievement_ring"></div>
                        <div className="epic_testimonial_achievement_content">
                          <div className="epic_testimonial_achievement_icon">🚀</div>
                          <span className="epic_testimonial_achievement_text">{testimonial.placement}</span>
                        </div>
                      </div>

                      {/* Action Portal */}
                      <a
                      href={testimonial.fullStoryUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="epic_testimonial_explore_btn"
                    >
                      <div className="epic_testimonial_btn_energy"></div>
                      <span>Read Full Story</span>
                      <div className="epic_testimonial_btn_arrow">→</div>
                    </a>
                    </div>


                  </div>
                 );
        })}
              </div>
            ))}
          </div>
        </div>

        {/* Navigation Controls */}
        <button
          className="epic_testimonial_nav_portal epic_testimonial_nav_next"
          onClick={nextSlide}
          onMouseEnter={() => setIsAutoPlaying(false)}
        >
          <div className="epic_testimonial_nav_energy"></div>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M9 18L15 12L9 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </button>
      </div>

      {/* Quantum Navigation */}
      <div className="epic_testimonial_quantum_nav">
      {Array.from({ length: totalPages }).map((_, index) => (
          <button
            key={index}
            className={`epic_testimonial_quantum_dot ${currentSlide === index ? 'epic_testimonial_quantum_active' : ''}`}
            onClick={() => goToSlide(index)}
          >
            <div className="epic_testimonial_quantum_core"></div>
            <div className="epic_testimonial_quantum_field"></div>
          </button>
        ))}
      </div>

      {/* YouTube Video Modal */}
      {showVideoModal && currentVideo && (
        <div className="epic_testimonial_video_modal_overlay" onClick={closeVideoModal}>
          <div className="epic_testimonial_video_modal_container" onClick={(e) => e.stopPropagation()}>
            {/* Modal Header */}
            <div className="epic_testimonial_modal_header">
              <div className="epic_testimonial_modal_title">
                <div className="epic_testimonial_modal_profile">
                  <img src={currentVideo.image} alt={currentVideo.name} />
                  <div>
                    <h3>{currentVideo.name}</h3>
                    <span>{currentVideo.company}</span>
                  </div>
                </div>
              </div>

              {/* Close Button */}
              <button className="epic_testimonial_modal_close" onClick={closeVideoModal}>
                <div className="epic_testimonial_close_energy"></div>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </button>
            </div>

            {/* Video Container */}
            <div className="epic_testimonial_video_container_modal">
              <div className="epic_testimonial_video_frame_modal">
                <iframe
                  src={currentVideo.videoUrl}
                  title={`${currentVideo.name} Testimonial`}
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                  className="epic_testimonial_youtube_iframe"
                ></iframe>

                {/* Holographic Overlay for Video */}
                <div className="epic_testimonial_video_holo_effects">
                  <div className="epic_testimonial_holo_corner epic_testimonial_holo_tl"></div>
                  <div className="epic_testimonial_holo_corner epic_testimonial_holo_tr"></div>
                  <div className="epic_testimonial_holo_corner epic_testimonial_holo_bl"></div>
                  <div className="epic_testimonial_holo_corner epic_testimonial_holo_br"></div>
                </div>
              </div>
            </div>

            {/* Modal Footer with Success Info */}
            <div className="epic_testimonial_modal_footer">
              <div className="epic_testimonial_modal_success_metrics">
                <div className="epic_testimonial_modal_metric">
                  <span className="epic_testimonial_modal_metric_icon">💰</span>
                  <span className="epic_testimonial_modal_metric_text">{currentVideo.salary}</span>
                </div>
                <div className="epic_testimonial_modal_metric">
                  <span className="epic_testimonial_modal_metric_icon">⚡</span>
                  <span className="epic_testimonial_modal_metric_text">{currentVideo.duration}</span>
                </div>
                <div className="epic_testimonial_modal_metric">
                  <span className="epic_testimonial_modal_metric_icon">🚀</span>
                  <span className="epic_testimonial_modal_metric_text">{currentVideo.placement}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}


    </div>
  );
};

export default TestimonialReviews;